angular.module("impactx.tinymce", []).component("ixTinyMce", {
  bindings: {
    options: "<",
    label: "=",
    labelclass: "@",
    data: "<",
    name: "@",
    id: "@",
    disabled: "<",
    readonly: "=",
    readonlyvisible: "=",
    showerrors: "=",
    nolabel: "=",
    onValueChange: "&",
    trns: '<',
  },
  controller: [
    "$scope",
    function ixTinyMceController($scope) {
      this.useAngular =
        window.hasOwnProperty("ixUseAngularComponents") &&
        window.ixUseAngularComponents;

      console.log("Use Angular for TinyMCE:", this.useAngular);
      var ctrl = this;

      /*
       * Funktioniert nicht.
       */
      this.dataChanged = function (newData) {
        if (typeof newData === "object") {
          if (typeof ctrl.data === "object") {
            ctrl.data.value = newData.value;
          } else {
            ctrl.data = newData;
          }
          if (ctrl.onValueChange) {
            ctrl.onValueChange(newData.value);
          }
        }
      };
    },
  ],
  template:
    '<div ng-if="$ctrl.data">' +
    '<md-input-container ng-if="!$ctrl.useAngular" class="full-width md-input-has-placeholder">' +
    '<label for="{{$ctrl.id}}" ng-if="!$ctrl.nolabel" \
    class="{{$ctrl.labelclass}}">{{$ctrl.label !==undefined ? $ctrl.label : $ctrl.data.label}}</label>' +
    '<textarea id="{{$ctrl.id}}" ui-tinymce="$ctrl.options" ng-model="$ctrl.data.value" name="{{$ctrl.name}}" \
    ng-disabled="$ctrl.disabled" ng-if="!$ctrl.readonly">' +
    "</textarea>" +
    '<div ng-bind-html="$ctrl.data.value | trusted"' +
    'ng-if="$ctrl.readonly && $ctrl.readonlyvisible"></div>' +
    '<!--<div ng-if="$ctrl.showerrors" ng-messages="dialogData.subject.$error" md-auto-hide="false">' +
    '<div ng-message="required">{{::trns.required}}</div>' +
    "</div>-->" +
    "</md-input-container>" +
    '<div ng-if="$ctrl.useAngular">' +
    '<ixa-tiny-mce [options]="$ctrl.options" [data]="$ctrl.data" (data-change)="$ctrl.dataChanged($event)" \
    [disabled]="!!$ctrl.disabled" [name]="$ctrl.name" [id]="$ctrl.id" \
    [labelclass]="$ctrl.labelclass" [label]="$ctrl.label ? $ctrl.label : $ctrl.data.label" [nolabel]="$ctrl.nolabel" [readonly]="$ctrl.readonly" \
    [showerrors]="$ctrl.showerrors" [trns]="trns"></ixa-tiny-mce>' +
    "</div>" +
    "</div>",
});
